"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROPER = void 0;
const tab_1 = require("../../../tab");
exports.PROPER = {
    description: 'Capitalizes the first letter of the text and all other letters in the text after any character other than a letter. Converts all other letters to lowercase.',
    arg_names: ['string_to_transform'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
    ],
    args_description: ['text to transform'],
    return_type: tab_1.ColumnType.STRING,
};
